module.exports = __webpack_public_path__ + "af6882b7f54c9351235805cdc9a3c9e3.svg";